module.exports = __webpack_public_path__ + "gitlab_logo.341e9099a2926df599a53bc6360bc1e3.png";